import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';

import SubmitButton from './SubmitButton';
import { updateMultiSelect, toggleSlideStatus } from '../actions';

const ConnectedSelectWidget = props => {
  const {
    options,
    hasMulti,
    results_key,
    updateMultiSelect,
    slideIndex,
    fullpageApi,
    toggleSlideStatus,
  } = props;

  const customStyles = {
    container: provided => ({ ...provided, marginBottom: '16px' }),
    menu: provided => ({
      ...provided,
      color: '#000',
    }),
  };

  const handleNextQuestion = e => {
    toggleSlideStatus(slideIndex);
    updateMultiSelect({ results_key, value: e });

    const timer = setTimeout(() => {
      fullpageApi.moveSectionDown();
      clearTimeout(timer);
    }, 150);
  };

  const handleOnMenuOpen = () => {
    fullpageApi.setAllowScrolling(false);
    fullpageApi.setKeyboardScrolling(false);
    fullpageApi.setMouseWheelScrolling(false);
  };

  const handleOnMenuClose = () => {
    fullpageApi.setAllowScrolling(true);
    fullpageApi.setKeyboardScrolling(true);
    fullpageApi.setMouseWheelScrolling(true);
  };

  return (
    <form>
      <Select
        styles={customStyles}
        options={options}
        isMulti={hasMulti}
        onChange={handleNextQuestion}
        className="react-select-container"
        classNamePrefix="react-select"
        value={props[results_key]}
        onMenuOpen={handleOnMenuOpen}
        onMenuClose={handleOnMenuClose}
      />
      {slideIndex == 7 && hasMulti && props[results_key].length > 0 ? (
        <SubmitButton text="See Results" />
      ) : null}
    </form>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    [ownProps.results_key]: state[ownProps.results_key],
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleSlideStatus: result => dispatch(toggleSlideStatus(result)),
    updateMultiSelect: event => dispatch(updateMultiSelect(event)),
  };
};

const SelectWidget = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConnectedSelectWidget);

export default SelectWidget;
